module.exports = __webpack_public_path__ + "img/m-rizhiguanli.ae3c9c5b.svg";